// extracted by mini-css-extract-plugin
export var aggregationCell = "_52-n";
export var aggregationRow = "_52-m";
export var borderlessSpinnerContainer = "_52-3";
export var cardLayout = "_52-6";
export var cardLayoutNoFooter = "_52-9";
export var cardLayoutPageControl = "_52-8";
export var closeIcon = "_52-f";
export var columnHeaderSurface = "_52-b";
export var columnHeaderSurfaceDragOverlay = "_52-v";
export var columnHeaderSurfaceResizing = "_52-s";
export var contextMenuAnchor = "_52-1";
export var draggableColumnHeader = "_52-t";
export var draggableColumnHeaderOverlay = "_52-u";
export var expandIcon = "_52-g";
export var expanded = "_52-h";
export var filterDropdown = "_52-i";
export var filterDropdownDivider = "_52-d";
export var filterDropdownHeader = "_52-l";
export var filterDropdownItem = "_52-k";
export var filterDropdownModal = "_52-j _52-i";
export var filterItem = "_52-c";
export var normalCellWithAdjustableBorder = "_52-e";
export var pinButtonContainer = "_52-o";
export var pinIcon = "_52-p";
export var pinIconActive = "_52-q";
export var spinner = "_52-0";
export var spinnerContainer = "_52-2";
export var tableContainer = "_52-4";
export var tableContentDraggingColumns = "_52-a";
export var tableContentInner = "_52-7";
export var tableContentWrapper = "_52-5";
export var viewButtonContainer = "_52-r";